module Meevo.Plugins.EmployeeTemplatePromotions {
  "use strict";

    /**
    * Location Section of Employee Profile Change
    */
  export class LocationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplateSecurity> {
      
      templateSecurityRoleDetail: Model.DataDetail;

      templateSmartCenterDetail: Model.DataDetail;

      get isSecurityRoleRequired(): boolean {
        return this.model.securityRoles.length === 0;
      }

      addSecurityRole(): void {
        if (this.templateSecurityRoleDetail !== undefined
          && _.all(this.model.securityRoles, (sr) => { return sr.displayName !== this.templateSecurityRoleDetail.displayName })) {
          this.model.securityRoles.push(this.templateSecurityRoleDetail);
          this.templateSecurityRoleDetail = undefined;
        }
      }

      removeSecurityRole(index: number): void {
        this.model.securityRoles.splice(index, 1);
      }

      getSmartCenterCriteria(): any {
          let criteria: any = {};
          criteria.IncludeSystemSmartCenters = true;
          return criteria;
      }

      addSmartCenter(): void {
        if (this.templateSmartCenterDetail !== undefined
          && _.all(this.model.smartCenters, (sm) => { return sm.displayName !== this.templateSmartCenterDetail.displayName })) {
          {
            this.model.smartCenters.push(this.templateSmartCenterDetail);
            this.templateSmartCenterDetail = undefined;
          }
        }
      }

      removeSmartCenter(index: number): void {
        this.model.smartCenters.splice(index, 1);
      }
    }
}